import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import NovoCliente from './components/NovoCliente';
import ListaClientes from './components/ListaClientes';
import ListaUsuarios from './components/ListaUsuarios';
import ListaZenPDV from './components/ListaZenPDV';
import ListaZenGestao from './components/ListaZenGestao';
import ListaZenTag from './components/ListaZenTag';
import ListaZenMobile from './components/ListaZenMobile';
import ListaZenPass from './components/ListaZenPass';
import ZenPassUsuarios from './components/ZenPassUsuarios';

import EditarCliente from './components/EditarCliente';
import EditarUsuario from './components/EditarUsuario';
import NovoUsuario from './components/NovoUsuario';
import EditarPdv from './components/EditarPdv';
import NovoPDV from './components/NovoPdv';

import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import NovoClienteZenTagForm from './components/FormularioZenTag';
import NovoClienteZenGestaoForm from './components/FormularioZenGestao';
import NovoClienteZenMobileForm from './components/FormularioZenMobile';
import NovoClienteZenPassForm from './components/FormularioZenPass';

import ZentagUsuarios from './components/ZentagUsuarios';

import ListaVendedores from './components/ListaVendedores';
import NovoVendedor from './components/NovoVendedor';
import EditarVendedor from './components/EditarVendedor';
import ExtratoMensal from './components/ExtratoMensal';
import ListaRevendasDistribuidor from './components/ListaRevendasDistribuidor';
import FormularioRevendaDistribuidor from './components/FormularioRevendaDistribuidor';
import UsuariosRevendaDistribuidor from './components/UsuariosRevendaDistribuidor';
import FormUsuarioRevendaDistribuidor from './components/FormUsuarioRevendaDistribuidor';
import TabelasPrecoDistribuidor from './components/TabelasPrecoDistribuidor';
import { Permissoes } from './utils/permissoes';
import { clearAuthSession, isTokenExpired, setupInterceptors } from './services/api';

function AppRoutes() {
  const navigate = useNavigate();
  const [token, setToken] = useState(() => sessionStorage.getItem('token'));
  const [userName, setUserName] = useState(() => sessionStorage.getItem('userName') || '');

  const handleSessionLost = () => {
    clearAuthSession();
    setToken(null);
    setUserName('');
  };

  useEffect(() => {
    setupInterceptors(navigate, handleSessionLost);
  }, [navigate]);

  useEffect(() => {
    const stored = sessionStorage.getItem('token');
    if (stored && isTokenExpired(stored)) {
      handleSessionLost();
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const handleLogout = () => {
    handleSessionLost();
    navigate('/login', { replace: true });
  };

  const isAuthenticated = !!token && !isTokenExpired(token);

  return (
    <Routes>
      <Route
        path="/login"
        element={
          !isAuthenticated ? (
            <Login setToken={setToken} setUserName={setUserName} />
          ) : (
            <Navigate to="/home" />
          )
        }
      />
      <Route path="/" element={isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />} />

      {isAuthenticated && (
        <Route element={<Layout userName={userName} onLogout={handleLogout} />}>
          <Route path="/home" element={<PrivateRoute token={token}><Home token={token} /></PrivateRoute>} />
          <Route path="/clientes" element={<PrivateRoute token={token} permission={Permissoes.ClienteVisualizar}><ListaClientes token={token} /></PrivateRoute>} />
          <Route path="/clientes/novo" element={<PrivateRoute token={token} permission={Permissoes.ClienteCadastrar}><NovoCliente token={token} /></PrivateRoute>} />
          <Route path="/clientes/editar/:id" element={<PrivateRoute token={token} anyPermission={["cliente.cadastrar", "cliente.editar"]}><EditarCliente token={token} /></PrivateRoute>} />
          <Route path="/usuarios" element={<PrivateRoute token={token} anyPermission={["usuario.ver", "usuario.gerir"]}><ListaUsuarios token={token} /></PrivateRoute>} />
          <Route path="/usuarios/novo" element={<PrivateRoute token={token} anyPermission={["usuario.cadastrar", "usuario.gerir"]}><NovoUsuario token={token} /></PrivateRoute>} />
          <Route path="/usuarios/editar/:id" element={<PrivateRoute token={token} anyPermission={["usuario.editar", "usuario.gerir"]}><EditarUsuario token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenpdv" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenPdv"><ListaZenPDV token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zentag/list" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenTag"><ListaZenTag token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zentag/:id/usuarios" element={<PrivateRoute token={token} produto="produtoZenTag"><ZentagUsuarios token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zentag/novo" element={<PrivateRoute token={token} produto="produtoZenTag"><NovoClienteZenTagForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zentag/editar/:id" element={<PrivateRoute token={token} produto="produtoZenTag"><NovoClienteZenTagForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenpass/list" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenPass"><ListaZenPass token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenpass/novo" element={<PrivateRoute token={token} produto="produtoZenPass"><NovoClienteZenPassForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenpass/editar/:id" element={<PrivateRoute token={token} produto="produtoZenPass"><NovoClienteZenPassForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenpass/:id/usuarios" element={<PrivateRoute token={token} produto="produtoZenPass"><ZenPassUsuarios token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenmobile/list" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenMobile"><ListaZenMobile token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenmobile/novo" element={<PrivateRoute token={token} produto="produtoZenMobile"><NovoClienteZenMobileForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zengestao/list" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenGestao"><ListaZenGestao token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zengestao/novo" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenGestao"><NovoClienteZenGestaoForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zenmobile/editar/:id" element={<PrivateRoute token={token} produto="produtoZenMobile"><NovoClienteZenMobileForm token={token} /></PrivateRoute>} />
          <Route path="/licenciamento/zengestao/editar/:id" element={<PrivateRoute token={token} permission={Permissoes.LicencaVisualizar} produto="produtoZenGestao"><NovoClienteZenGestaoForm token={token} /></PrivateRoute>} />
          <Route path="/pdvs/novo" element={<PrivateRoute token={token} produto="produtoZenPdv"><NovoPDV token={token} /></PrivateRoute>} />
          <Route path="/pdvs/editar/:id" element={<PrivateRoute token={token} produto="produtoZenPdv"><EditarPdv token={token} /></PrivateRoute>} />
          <Route path="/vendedores" element={<PrivateRoute token={token}><ListaVendedores token={token} /></PrivateRoute>} />
          <Route path="/vendedores/novo" element={<PrivateRoute token={token}><NovoVendedor token={token} /></PrivateRoute>} />
          <Route path="/vendedores/editar/:id" element={<PrivateRoute token={token}><EditarVendedor token={token} /></PrivateRoute>} />
          <Route path="/extrato-mensal" element={<PrivateRoute token={token} permission={Permissoes.RelatorioAcessar}><ExtratoMensal token={token} /></PrivateRoute>} />
          <Route path="/extrato-cobranca" element={<PrivateRoute token={token} permission={Permissoes.RelatorioAcessar}><ExtratoMensal token={token} cobranca /></PrivateRoute>} />
          <Route path="/revendas" element={<PrivateRoute token={token} permission="revenda.ver"><ListaRevendasDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/revendas/novo" element={<PrivateRoute token={token} permission="revenda.cadastrar"><FormularioRevendaDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/revendas/editar/:id" element={<PrivateRoute token={token} anyPermission={["revenda.editar", "revenda.cadastrar"]}><FormularioRevendaDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/revendas/usuarios" element={<PrivateRoute token={token} anyPermission={["usuario.ver", "usuario.gerir"]}><UsuariosRevendaDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/revendas/usuarios/novo" element={<PrivateRoute token={token} anyPermission={["usuario.cadastrar", "usuario.gerir"]}><FormUsuarioRevendaDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/revendas/usuarios/editar/:id" element={<PrivateRoute token={token} anyPermission={["usuario.editar", "usuario.gerir"]}><FormUsuarioRevendaDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/tabelas-preco" element={<PrivateRoute token={token} permission={Permissoes.LicencaEditar}><TabelasPrecoDistribuidor token={token} /></PrivateRoute>} />
          <Route path="/tabelas-preco/novo" element={<PrivateRoute token={token} permission={Permissoes.LicencaEditar}><TabelasPrecoDistribuidor token={token} criar /></PrivateRoute>} />
          <Route path="/tabelas-preco/editar/:id" element={<PrivateRoute token={token} permission={Permissoes.LicencaEditar}><TabelasPrecoDistribuidor token={token} /></PrivateRoute>} />
        </Route>
      )}
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
